<template>
  <div class="asc-issue-grid">
    <asc-ag-grid-filter
      :key="`asc-issue-grid_${gridId}`"
      :grid-options="agGridOptions"
      :column-defs="getGridColumnDefs"
      :row-data="agGridRowData"
    ></asc-ag-grid-filter>
  </div>
</template>

<script>
import {
  AscAgGridAutocompleteFloatFilter,
  AscAgGridDateFloatFilter,
  AscAgGridFilter,
  AscTooltipCellRenderer,
} from '@/components/agGrid'
import { AscGridPropsMixin, AscGridMethodsMixin } from '@/components/mixins'
import { getFormattedDateTime } from '@/utilities/dates'

import { dateStringMatcher } from '@/components/agGrid/AgGridHelperMethods'
import { getFilterOptions } from '@/components/agGrid/AgGridOptions'

export default {
  name: 'AscUserManagementGrid',

  components: {
    AscAgGridFilter,
    AscAgGridAutocompleteFloatFilter,
    AscAgGridDateFloatFilter,
    AscTooltipCellRenderer,
  },

  mixins: [AscGridPropsMixin, AscGridMethodsMixin],

  props: {
    addUser: {
      type: Function,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      agGridOptions: getFilterOptions(this, {
        defaultColDef: {
          tooltipComponent: 'AscTooltipCellRenderer',
        },
        rowSelection: 'single',
        onGridReady: this.handleGridReady,
        onFirstDataRendered: this.handleFirstDataRendered,
        onGridSizeChanged: this.handleGridSizeChanged,
        onCellClicked: this.handleCellClicked,
      }),
    }
  },

  computed: {
    mappedValues() {
      return this.values
    },
    agGridRowData() {
      this.resetLocalStorage(this.localStorageName)
      return this.mappedValues
    },
    getGridColumnDefs() {
      return [
        {
          headerName: 'User Id',
          width: 80,
          minWidth: 80,
          field: 'userId',
          filter: 'agNumberColumnFilter',
        },
        {
          headerName: 'First Name',
          field: 'firstName',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Last Name',
          field: 'lastName',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Email',
          field: 'userEmail',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Company',
          field: 'company',
          filter: 'agTextColumnFilter',
          valueGetter: value => value.data.company.name,
        },
        {
          headerName: 'Last Login',
          field: 'lastLoggedIn',
          width: 155,
          minWidth: 155,
          filter: 'agTextColumnFilter',
          filterParams: {
            textMatcher: dateStringMatcher,
          },
          floatingFilterComponent: 'AscAgGridDateFloatFilter',
          floatingFilterComponentParams: {
            suppressFilterButton: true,
            items: this.values,
          },
          valueFormatter: data => getFormattedDateTime(data.value),
          comparator: this.sortDate,
        },
        {
          headerName: 'Airlines',
          width: 100,
          minWidth: 100,
          field: 'airlineCount',
          filter: 'agNumberColumnFilter',
        },
      ]
    },
  },

  methods: {
    handleCellClicked(event) {
      if (event) {
        this.onOpen(event.data)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-sort-icon {
  color: $primary_black;
  position: absolute;
  top: 14px;
  right: 16px;
}

.asc-filter-icon {
  color: $primary_black;
}
</style>
